// extracted by mini-css-extract-plugin
module.exports = {"formCheckbox__label":"form-checkbox_formCheckbox__label__Er18b","formCheckbox__input":"form-checkbox_formCheckbox__input__7MSR6"};